import { render, staticRenderFns } from "./ResourcesEditing.vue?vue&type=template&id=ef7628ce"
import script from "./ResourcesEditing.vue?vue&type=script&lang=js"
export * from "./ResourcesEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports